
import React from 'react';
import {func, string, object} from 'prop-types';
import {map} from 'lodash';

const ToggleLinks = ({cssClass, toggleLinks, selectedToggleLink, toggleLinkOnClickHandler}) => {

    const linkLabel = (selectedLink, linkOnClickHandler) =>
        (linkKey, labelText) => selectedLink === linkKey ? <span>{labelText}</span> :
            <span className='spark-link' onClick={() => linkOnClickHandler(linkKey)}>{labelText}</span>;

    const getLinkLabel = linkLabel(selectedToggleLink, toggleLinkOnClickHandler);

    const tabLinks = [];
    let index = 0;
    map(toggleLinks, (eachToggleLink, key) => {
        tabLinks.push(
            <span key={key}>
                {index++ === 0 ? '' : <span className='spark-mar-r-2 spark-mar-l-2'>|</span>}
                {getLinkLabel(eachToggleLink.KEY, eachToggleLink.LABEL_TEXT)}
            </span>
        );
    });

    return <div className={`row tabs-link-container${cssClass ? ` ${cssClass}` : ''}`}>{tabLinks}</div>;
};

ToggleLinks.propTypes = {
    cssClass: string,
    toggleLinks: object.isRequired,
    selectedToggleLink: string.isRequired,
    toggleLinkOnClickHandler: func.isRequired
};

export default ToggleLinks;
